import styled from 'styled-components';
import { Drawer } from 'antd';

export const SbDrawerStyled = styled(Drawer)`
  /* ── Close button positioned on the right ── */
  .ant-drawer-close {
    order: 1;
  }

  /* ── Body scrollable ── */
  .ant-drawer-body {
    padding: 17px 28px;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
  }
    .ant-drawer-title {
    font-size: 30px;
    font-weight: 600;
  }
`;
